import React from 'react';
import styles from './client-portal.styles.css';
import Tab from './client-tab.component.js';
import ClientMenu from './client-menu.component.js';
import Help from './help.component.js';
import { track } from './analytics.helper'
import { CpTooltip, CpButton } from 'canopy-styleguide!sofe'

export default function ClientPortal(props) {
  const {
    tabs,
    hash,
    logo_url,
    company_name,
    appointmentSchedulerLink,
  } = props;
    return (
      <div>
        <div className={`${styles.navbar}`}>
          <div className={styles.left}>
            {
              logo_url &&
              <img src={logo_url} alt={company_name || 'Company Logo'} className={styles.whiteLabelLogo}/>
            }
            {
              tabs.map((tab, index) => (
                <Tab
                  key={index}
                  tab={tab}
                  active={isActive(tab.matches, hash)}
                />
              ))
            }
          </div>
          <div style={{flex: 1}} />
          <div className={styles.right}>
            {!!appointmentSchedulerLink?.enabled && (
              <CpTooltip
                text={'Schedule an appointment'}
              >
                <CpButton
                  btnType="icon"
                  icon='misc-calendar'
                  aria-label="Schedule an appointment"
                  onClick={() => {
                    window.open(appointmentSchedulerLink?.link, '_blank', 'noopener=yes,noreferrer=yes')
                    track('third-party-link_clicked', { linkClicked: 'Scheduler' })
                  }}
                />
              </CpTooltip>
            )}
            <ClientMenu
              {...props}
            />
            <Help activeClientId={props.activeClient?.id} />
          </div>
        </div>
      </div>
    )
}

function isActive(regexes, hash) {
  return regexes.reduce((active, regex) => {
    return active ? active : new RegExp(regex).test(hash);
  }, false);
}
